var ViewChangeController = (function () {
    function ViewChangeController() {
    }
    ViewChangeController.$inject = [];
    return ViewChangeController;
}());
export var ViewChageComponent = {
    bindings: {
        isListView: '=',
    },
    controller: ViewChangeController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/viewchange',
};
